import {
  ActionsObservable,
  combineEpics,
  StateObservable
} from 'redux-observable';
import { from, of } from 'rxjs';
import { catchError, exhaustMap, mergeMap, startWith } from 'rxjs/operators';
import axios from '../../axios-pod';
import { IState } from '../../models/states';
import actionTypes from '../../utilities/actionTypes';
import {
  fetchPlayoutUrlsPending,
  fetchPlayoutUrlsSuccess,
  IFetchPlayoutUrls,
  updatePlayoutFeeds
} from '../actions/playoutActions';

export const onLoadFeeds = (
  action$: ActionsObservable<IFetchPlayoutUrls>,
  state$: StateObservable<IState>
) =>
  action$.ofType(actionTypes.FETCH_PLAYOUT_URLS).pipe(
    exhaustMap((action: IFetchPlayoutUrls) => {
      return from(
        axios.get('/playout_urls', {
          params: {
            userId: state$.value.user.userInfo.userId,
            customers: action.customers.join(',')
          }
        })
      ).pipe(
        mergeMap(response => {
          // const oldPlayoutFeeds = action.pubnub.fetchMessages(
          //   {
          //     channels: ['acj.amagi.tv#ABSOS#XYZ'],
          //     count: 1
          //   },
          //   (status, res) => {
          //     // handle response
          //     console.log(res);
          //   }
          // );

          // Object.keys(oldPlayoutFeeds.channels).map(channelName =>{

          // } )
          const result: any[] = [
            fetchPlayoutUrlsSuccess(response.data.result, action.feedCodes),
            updatePlayoutFeeds([])
          ];
          return result;
        }),
        startWith(fetchPlayoutUrlsPending()),
        catchError(_ => of())
      );
    })
  );

export default combineEpics(onLoadFeeds);
// .pipe(
//   mergeMap((action: IFetchPlayoutUrls) => {
//     const r = [];
//     action.pubnub.history(
//       {
//         channel: 'channel1',
//         count: 100 // 100 is the default
//         // stringifiedTimeToken: true // false is the default
//       },
//       (status, res) => {
//         console.log(res, 'test6');
//       }
//     );
//     // const result: any[] = [
//     //   fetchPlayoutUrlsSuccess(response.data.result, action.feedCodes)
//     // ];
//     return r;
//   }),
//   catchError(_ => of())
